// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ReactImageCrop = require("react-image-crop").default;
let JsxRuntime = require("react/jsx-runtime");

function tToJs(crop) {
  return {
    unit: crop.unit,
    x: crop.x,
    y: crop.y,
    aspect: crop.aspect,
    width: crop.width,
    height: crop.height
  };
}

function tFromJs(crop) {
  let match = crop.unit;
  let tmp = match === "px" ? "px" : "%";
  return {
    unit: tmp,
    x: crop.x,
    y: crop.y,
    aspect: crop.aspect,
    width: crop.width,
    height: crop.height
  };
}

let Crop = {
  tToJs: tToJs,
  tFromJs: tFromJs
};

((require('react-image-crop/dist/ReactCrop.css')));

let JS = {};

function ReactImageCrop$1(props) {
  let onComplete = props.onComplete;
  let onChange = props.onChange;
  return JsxRuntime.jsx(ReactImageCrop, {
    src: props.src,
    crop: Stdlib_Option.map(props.crop, tToJs),
    onImageLoaded: Stdlib_Option.map(props.onImageLoaded, f => (image => f(image))),
    onChange: onChange !== undefined ? (px, pct) => onChange(tFromJs(px), tFromJs(pct)) : undefined,
    onComplete: onComplete !== undefined ? (px, pct) => onComplete(tFromJs(px), tFromJs(pct)) : undefined,
    minWidth: props.minWidth,
    minHeight: props.minHeight,
    keepSelection: props.keepSelection,
    circularCrop: props.circularCrop
  });
}

let make = ReactImageCrop$1;

exports.Crop = Crop;
exports.JS = JS;
exports.make = make;
/*  Not a pure module */
